import { render } from "./TaxInvoice.vue?vue&type=template&id=5253c358&scoped=true"
import script from "./TaxInvoice.vue?vue&type=script&lang=js"
export * from "./TaxInvoice.vue?vue&type=script&lang=js"

import "./TaxInvoice.vue?vue&type=style&index=0&id=5253c358&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5253c358"]])

export default __exports__